import {Component, EventEmitter, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Router} from '@angular/router';

@Component({
  templateUrl: './confirm-add-supported-bank-dialog.component.html',
  styleUrls: ['../../../shared/notification/notification.shared.scss']
})
export class ConfirmAddSupportedBankDialogComponent {

  private areYouSure = new EventEmitter<void>();

  constructor(@Inject(MAT_DIALOG_DATA) public data,
              private router: Router,
              private dialogRef: MatDialogRef<ConfirmAddSupportedBankDialogComponent>) {
  }

  resolve(areYouSure) {
    this.areYouSure.emit(areYouSure);
    this.dialogRef.close();
  }

  public promise() {
    return new Promise<void>((resolve, reject) => this.areYouSure.subscribe(sure => sure ? resolve() : reject()));
  }

  add() {
    this.resolve(true);
  }

  cancel() {
    this.resolve(false);
  }

  import() {
    this.dialogRef.close();
    this.router.navigate(['/bewind/' + this.data.clientId + '/importeren']);
  }
}
